/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module widget
 */
export { default as Widget } from './widget.js';
export { default as WidgetToolbarRepository } from './widgettoolbarrepository.js';
export { default as WidgetResize } from './widgetresize.js';
export { default as WidgetTypeAround } from './widgettypearound/widgettypearound.js';
export * from './utils.js';
import './augmentation.js';
